// extracted by extract-css-chunks-webpack-plugin
module.exports = {"popover":"_2pj9iL","popover-overlay-trigger":"_3wPWP1"};